import api from "../core/http";

/**
 * Reading goals. Every call carries the device timezone so day boundaries
 * match what the user perceives (pace maths runs in local calendar days).
 *
 * Errors are NOT swallowed here: creation relies on a 409 to offer replacing
 * an existing goal, and the modals show the API message on failure.
 */
const timezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const withTimezone = (body = {}) => ({ ...body, timezone: timezone() });

export const getGoals = () =>
  api
    .get("/v1/goals", { params: { timezone: timezone() } })
    .then((res) => res.data);

export const getGoalOrders = () =>
  api.get("/v1/goals/orders").then((res) => res.data);

export const checkGoalFeasibility = (goal) =>
  api.post("/v1/goals/feasibility", withTimezone(goal)).then((res) => res.data);

export const createGoal = (goal) =>
  api.post("/v1/goals", withTimezone(goal)).then((res) => res.data);

export const updateGoal = (goalId, changes) =>
  api
    .patch(`/v1/goals/${goalId}`, withTimezone(changes))
    .then((res) => res.data);

export const pauseGoal = (goalId) =>
  api.post(`/v1/goals/${goalId}/pause`, withTimezone()).then((res) => res.data);

export const resumeGoal = (goalId) =>
  api
    .post(`/v1/goals/${goalId}/resume`, withTimezone())
    .then((res) => res.data);

export const cancelGoal = (goalId) =>
  api
    .post(`/v1/goals/${goalId}/cancel`, withTimezone())
    .then((res) => res.data);

export const acknowledgeGoal = (goalId) =>
  api
    .post(`/v1/goals/${goalId}/acknowledge`, withTimezone())
    .then((res) => res.data);
